const vueTelInputConfig = {
  mode: "international",
  defaultCountry: "FR",
  autoFormat: true,
  autoDefaultCountry: true,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
};

export default vueTelInputConfig;
